import React, { useMemo } from "react";
import ConnectExistingIssueToItemModalWrapper from "../../../../../../app/ConnectExistingIssueToItemModalWrapper";
import { usePutIssueConnectMutation } from "../../../../../../../openapi";

export const ConnectIssueModal: React.FC<{
  projectId: string;
  boardId?: string;
  sourceIssueId: string;
  opened: boolean;
  onClose: () => void;
  blockedIssueIds?: string[];
}> = ({ projectId, boardId, sourceIssueId, opened, onClose, blockedIssueIds = [] }) => {
  const [connectIssues] = usePutIssueConnectMutation();

  const defaultIssueBoard = useMemo(() => (boardId != null ? { _id: boardId, name: "" } : undefined), [boardId]);
  const blockedIds = useMemo(
    () => Array.from(new Set([sourceIssueId, ...blockedIssueIds].filter(Boolean))),
    [blockedIssueIds, sourceIssueId],
  );

  return (
    <ConnectExistingIssueToItemModalWrapper
      opened={opened}
      defaultIssueBoard={defaultIssueBoard}
      onConnected={async (selectedBoardId, targetIssueId) => {
        await connectIssues({
          body: {
            projectId,
            issueBoardId: selectedBoardId,
            sourceIssueId,
            targetIssueId,
            action: "CONNECT",
          },
        });
        onClose();
      }}
      projectId={projectId}
      closeModal={onClose}
      blockedIssueIds={blockedIds}
      allowedTypes={["ISSUE"]}
      modalTitle="Koble sak til"
    />
  );
};
